import {Injectable, OnDestroy, OnInit} from '@angular/core';
import {ParentAPIService} from '../parent.api.service';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {FieldResult} from "../../model/api/field-result";
import {FieldRequest} from "../../model/api/field-request";
import {CrystalclearCommonBackUrl} from "../config/crystalclear-common-back-url";
import {ExchangeDetail} from "../../model/exchange/exchange-detail";
import {AccountType} from "../../model/exchange/account-type";
import {AccountDefinition} from "../../model/customer/account-definition";
import {Customer} from "../../model/customer/customer";
import {Contract} from "../../model/exchange/contract";
import {BankAccount} from "../../model/customer/bank-account";
import {Trader} from "../../model/customer/trader";
import {TradingEnvironment} from "../../model/exchange/trading-environment";
import {Source} from "../../model/mapping/source";
import {Fee} from "../../model/mapping/fee";
import {AccountTrader} from "../../model/customer/account-trader";
import {BrokerageTable} from "../../model/customer/brokerage-table";
import {Broker} from "../../model/customer/broker";
import {ExecTrader} from "../../model/customer/exec-trader";
import {MoneyOwner} from "../../model/customer/money-owner";

@Injectable({
  providedIn: 'root'
})
export class CommonFieldService extends ParentAPIService implements OnInit, OnDestroy {

  constructor(http: HttpClient) {

    super(http);
  }

  ngOnInit(): void {
  }


  ngOnDestroy() {
  }

  public getCountries(request: FieldRequest): Observable<FieldResult<any>> {
    return this.postStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_COUNTRIES, request);
  }

  public getTimeZones(request: FieldRequest): Observable<FieldResult<any>> {
    return this.postStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_TIMEZONES, request);
  }

  public getCurrencies(request: FieldRequest): Observable<FieldResult<string>> {
    return this.postStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_CURRENCIES, request);
  }

  public getLanguages(request: FieldRequest): Observable<FieldResult<any>> {
    return this.postStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_LANGUAGES, request);
  }

  public getVatRates(request: FieldRequest): Observable<FieldResult<any>> {
    return this.postStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_VATRATES, request);
  }

  public getOwners(request: FieldRequest): Observable<FieldResult<any>> {
    return this.postStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_OWNERS, request);
  }

  public getBrokers(request: FieldRequest): Observable<FieldResult<Broker>> {
    return this.postStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_BROKERS, request);
  }

  public getExecTraders(request: FieldRequest): Observable<FieldResult<ExecTrader>> {
    return this.postStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_EXEC_TRADERS, request);
  }

  public getCustomers(request: FieldRequest): Observable<FieldResult<Customer>> {
    return this.postStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_CUSTOMERS, request);
  }

  public getAccounts(request: FieldRequest): Observable<FieldResult<AccountDefinition>> {
    return this.postStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_ACCOUNTS, request);
  }

  public getAccountTraders(request: FieldRequest): Observable<FieldResult<AccountTrader>> {
    return this.postStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_ACCOUNT_TRADERS, request);
  }

  public getContracts(request: FieldRequest): Observable<FieldResult<Contract>> {
    return this.post(CrystalclearCommonBackUrl.GET_COMMON_FIELD_CONTRACTS, request);
  }

  public getClearingHouses(request: FieldRequest): Observable<FieldResult<any>> {
    return this.postStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_CLEARINGHOUSES, request);
  }

  public getExchangeCodes(request: FieldRequest): Observable<FieldResult<ExchangeDetail>> {
    return this.postStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_EXCHANGECODES, request);
  }

  public getAccountTypes(request: FieldRequest): Observable<FieldResult<AccountType>> {
    return this.postStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_ACCOUNTTYPES, request);
  }
  public getBankAccounts(request: FieldRequest): Observable<FieldResult<BankAccount>> {
    return this.postStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_BANK_ACCOUNT, request);
  }

  public getMoneyOwner(request: FieldRequest): Observable<FieldResult<MoneyOwner>> {
    return this.postStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_MONEY_OWNER, request);
  }


  public getBrokerageTables(request: FieldRequest): Observable<FieldResult<BrokerageTable>> {
    return this.postStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_BROKERAGE_TABLE, request);
  }

  public getTraders(request: FieldRequest): Observable<FieldResult<Trader>> {
    return this.postStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_TRADER, request);
  }

  public clearTraders() {
    this.clearStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_TRADER);
  }

  public getTradingEnvironments(request: FieldRequest): Observable<FieldResult<TradingEnvironment>> {
    return this.postStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_TRADING_ENVIRONMENTS, request);
  }

  public getSources(request: FieldRequest): Observable<FieldResult<Source>> {
    return this.postStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_SOURCE, request);
  }

  public getFees(request: FieldRequest): Observable<FieldResult<Fee>> {
    return this.postStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_FEE, request);
  }

  public getSecurityUsers(request: FieldRequest): Observable<FieldResult<any>> {
    return this.postStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_SECURITY_USER, request);
  }

  public getClearingUsers(request: FieldRequest): Observable<FieldResult<any>> {
    return this.postStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_CLEARING_USER, request);
  }

  public getAuthorities(request: FieldRequest): Observable<FieldResult<any>> {
    return this.postStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_AUTHORITIES, request);
  }

  public getUserGroups(request: FieldRequest): Observable<FieldResult<any>> {
    return this.postStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_USER_GROUP, request);
  }

  public getInvoices(request: FieldRequest): Observable<FieldResult<any>> {
    return this.postStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_BILLING_INVOICES, request);
  }

  public clearStorage(): void {
      this.clearStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_COUNTRIES);
      this.clearStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_CURRENCIES);
      this.clearStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_LANGUAGES);
      this.clearStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_VATRATES);
      this.clearStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_OWNERS);
      this.clearStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_BROKERS);
      this.clearStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_EXEC_TRADERS);
      this.clearStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_BROKERAGE_TABLE);
      this.clearStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_CUSTOMERS);
      this.clearStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_ACCOUNTS);
      this.clearStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_ACCOUNT_TRADERS);
      this.clearStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_CLEARINGHOUSES);
      this.clearStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_EXCHANGECODES);
      this.clearStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_ACCOUNTTYPES);
      this.clearStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_BANK_ACCOUNT);
      this.clearStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_MONEY_OWNER);
      this.clearStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_TRADER);
      this.clearStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_TRADING_ENVIRONMENTS);
      this.clearStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_SOURCE);
      this.clearStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_FEE);
      this.clearStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_SECURITY_USER);
      this.clearStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_CLEARING_USER);
      this.clearStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_AUTHORITIES);
      this.clearStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_USER_GROUP);
      this.clearStore(CrystalclearCommonBackUrl.GET_COMMON_FIELD_BILLING_INVOICES);
  }


}
